var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('router-link',{attrs:{"to":_vm.url}},[_c('img',{staticClass:"logo-light",attrs:{"src":_vm.lightLogo,"alt":"Corporate Logo"}}),_c('img',{staticClass:"logo-dark",attrs:{"src":_vm.darkLogo,"alt":"Corporate Logo"}}),_c('span',{staticClass:"theme-gradient"},[_vm._v("以人为本，以质取优，以诚取胜")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }